/** A Platform job serial carried by the AutoCosting page URL. */
export function platformSerial(search: string): string | null {
  const serial = new URLSearchParams(search).get("serial")?.trim() ?? "";
  return serial && serial.length <= 128 ? serial : null;
}

/** Remove only the consumed serial while preserving unrelated query parameters. */
export function platformSheetId(search: string): string | null {
  const id = new URLSearchParams(search).get("sheetId")?.trim() ?? "";
  return /^[a-zA-Z0-9-]{1,100}$/.test(id) ? id : null;
}

export function withoutPlatformSerial(url: URL): string {
  url.searchParams.delete("serial");
  url.searchParams.delete("ownerEmail");
  url.searchParams.delete("sheetId");
  return url.pathname + url.search + url.hash;
}
